import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles?.length && !allowedRoles.includes(user?.role) && !(allowedRoles.includes('OpenPlayOrganiser') && user?.hasOpenPlayOrganiserAccess)) {
    const destination = user?.role === 'Admin'
      ? '/select-owner'
      : (['CourtOwner', 'VenueManager'].includes(user?.role) ? '/dashboard' : (user?.role === 'BookingStaff' ? '/bookings' : user?.role === 'OpenPlayOrganiser' ? '/openplays' : '/login'));
    return <Navigate to={destination} replace />;
  }

  return children;
}
